<template>
  <v-card class="px-2 py-3">
    <v-layout column style="height: 100%">
      <div v-if="item.icon">
        <div class="icon-2">
          <img style="width: 17px" :src="`/static/img/img-icon/${item.icon}`" />
        </div>
      </div>
      <div v-else-if="item.iconText">
        <span class="icon">{{ item.iconText }}</span>
      </div>

      <v-layout column class="pt-2" style="margin: 0; min-height: 120px" justify-space-between>
        <v-flex class="pr-1">
          <div class="primary--text" style="color: black; font-weight: bold">
            {{ item.name
            }}<sup
              v-if="item.recommended"
              class="ml-2"
              style="font-size: 12px; color: red; font-weight: normal"
              >Recommended</sup
            >
            <sup
              v-if="item.lineText"
              class="ml-2"
              style="font-size: 12px; color: #02b956; font-weight: normal"
              >{{ item.lineText }}</sup
            >
          </div>
          <div v-if="item.desc" style="font-size: 12px; color: gray">{{ item.desc }}</div>
          <div class="mt-2" style="font-size: 12px">{{ questionCount }} Automatic question</div>
        </v-flex>
        <v-layout
          class="mb-0"
          style="width: 100%; height: 100%; align-self: end"
          row
          justify-end
          align-end
        >
          <v-btn class="m-0" color="primary" outline @click="createIntent()">select</v-btn>
        </v-layout>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: {
    item: {
      require: true,
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    questionCount() {
      if (this.item && this.item.val) {
        return this.item.val.split(',').length
      } else {
        return 0
      }
    }
  },
  methods: {
    async createIntent(times = 0) {
      const vm = this
      let intentName = this.item.intentName ? this.item.intentName : 'empty'
      const q_val = this.item.val
      if (times) {
        intentName += `_${new Date().getTime()}`
      }
      const data = {
        pageid: vm.selectedBot.pageid,
        intentname: intentName,
        q_type: 'text',
        a_type: 'json',
        q_val,
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: true,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        follow_up_fb_quick_reply: '',
        follow_up_fb_val: null,
        follow_up_ig_quick_reply: null,
        follow_up_ig_val: null,
        follow_up_line_quick_reply: '',
        follow_up_line_val: null,
        follow_up_quick_reply: null,
        follow_up_status: null,
        follow_up_type: 'json',
        follow_up_val: '[[]]',
        follow_up_within_seconds: null,
        follow_up_whatsapp_quick_reply: '',
        follow_up_whatsapp_val: null,
        exceptpostidlist: '',
        post_keywords: '',
        onlytime: false,
        quick_reply: '',
        follow_up_usertags: '',
        intentgroup: null
      }
      let response = false
      if (times) {
        response = {
          value: true
        }
      } else {
        response = await vm.$swal.fire({
          title: vm.$t('คุณต้องการเพิ่มบทสนทนาหัวข้อ {name} สำหรับเพจของคุณ', {
            // eslint-disable-next-line no-useless-escape
            name: vm.item.intentName.replace(/\<|\>/g, '')
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
      }
      if (response && response.value) {
        vm.$store.dispatch('loading')
        const response = await api.addIntent(data, null, true)
        if (response && response.data && response.data.id) {
          data.id = response.data.id
          vm.$store.dispatch('loading')
          vm.$emit('created')
        }
        if (
          response &&
          response.data &&
          response.data.responsecode == 400 &&
          response.data.result === 'DUPLICATE_INTENT_NAME'
        ) {
          vm.$store.dispatch('loading')
          this.createIntent((times += 1))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  background-color: aliceblue;
  padding: 10px;
  border-radius: 50%;
}
.icon-2 {
  background-color: aliceblue;
  padding: 10px;
  border-radius: 50%;
  display: flex;
  width: max-content;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentTemplate/IntentTemplateItem.vue